// @ts-nocheck comment
import { createBrowserHistory, BrowserHistory } from 'history'

const history: BrowserHistory = createBrowserHistory()

export default history
